import createIcon from '../../createIcon';

/**
 * @component @name CastConnected
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSAxOFYyMUg0QzQgMTkuMzQgMi42NiAxOCAxIDE4Wk0xIDE0VjE2QzMuNzYgMTYgNiAxOC4yNCA2IDIxSDhDOCAxNy4xMyA0Ljg3IDE0IDEgMTRaTTE5IDdINVY4LjYzQzguOTYgOS45MSAxMi4wOSAxMy4wNCAxMy4zNyAxN0gxOVY3Wk0xIDEwVjEyQzUuOTcgMTIgMTAgMTYuMDMgMTAgMjFIMTJDMTIgMTQuOTIgNy4wNyAxMCAxIDEwWk0yMSAzSDNDMS45IDMgMSAzLjkgMSA1VjhIM1Y1SDIxVjE5SDE0VjIxSDIxQzIyLjEgMjEgMjMgMjAuMSAyMyAxOVY1QzIzIDMuOSAyMi4xIDMgMjEgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CastConnected = createIcon('CastConnected', [
  [
    'path',
    {
      d: 'M1 18V21H4C4 19.34 2.66 18 1 18ZM1 14V16C3.76 16 6 18.24 6 21H8C8 17.13 4.87 14 1 14ZM19 7H5V8.63C8.96 9.91 12.09 13.04 13.37 17H19V7ZM1 10V12C5.97 12 10 16.03 10 21H12C12 14.92 7.07 10 1 10ZM21 3H3C1.9 3 1 3.9 1 5V8H3V5H21V19H14V21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3Z',
      key: '1v8v77',
    },
  ],
]);

export default CastConnected;
